import { useTranslation } from 'react-i18next';
import { getLocalized } from '../../utils/i18nHelpers';
import { FiChevronLeft, FiChevronRight } from 'react-icons/fi';
import { Link } from 'react-router-dom';

const MarqueeBar = ({ text, active = true, settings }) => {
    const { i18n, t } = useTranslation();
    const displayText = settings?.homepage?.marquee ? getLocalized(settings.homepage.marquee, 'text', i18n.language) : (text || "TÜM ÜRÜNLERDE 3 AL 2 ÖDE | KAMPANYA DETAYLARI İÇİN TIKLAYIN");

    if (!active || !displayText) return null;

    return (
        <div className="w-full bg-[var(--primary-color)] text-gray-950 py-2.5 relative z-30 flex items-center justify-between px-4 lg:px-8">
            <button className="text-gray-950 hover:opacity-75 transition-opacity" aria-label="Önceki duyuru">
                <FiChevronLeft className="text-xl stroke-[3]" />
            </button>
            
            <div className="text-center flex-1">
                <Link to="/products" className="text-xs md:text-sm font-black tracking-widest uppercase text-gray-950 hover:underline">
                    {displayText}
                </Link>
            </div>

            <button className="text-gray-950 hover:opacity-75 transition-opacity" aria-label="Sonraki duyuru">
                <FiChevronRight className="text-xl stroke-[3]" />
            </button>
        </div>
    );
};

export default MarqueeBar;
